module.exports = __webpack_public_path__ + "static/media/icon-lists.aff5ffcd.png";